import { useMemo } from "react";
import useSWR from "swr";

import { applicationEndpoints } from "@api/Endpoints";
import { OrganizationApplicationsResponse } from "@applications/models/ApplicationJsonModel";

import { fetcher } from "@utils/swrUtils";

export function useGetAssociatedApplications() {
  const url = applicationEndpoints.getCurrentOrganizationApplications();

  const { data, error, isLoading } = useSWR<
    OrganizationApplicationsResponse,
    Error
  >(url, fetcher, { revalidateOnFocus: false });

  return useMemo(
    () => ({ applications: data?.applications, isLoading, error }),
    [data, isLoading, error]
  );
}
